import { combineReducers } from "redux";
import { reducer as form } from "./form/form.reducer";
import { reducer as list } from "./list/list.reducer";

export const reducer = combineReducers({
  form,
  list,
});
